import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Date from '../date';
import Icon, { GLYPHS } from '../icon';
import Modal from '../Modal';

const UpdateStripeDataWarningModal = props => (
  <Modal close={props.onClose} className="c-update-stripe-data-modal" showCloseButton display-if={props.isModalVisible}>
    <div className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-mt u-mb+">
      <Icon
        className="c-image-asset-upload__icon u-mt u-mb- u-font-color-grey"
        size="large"
        glyph={GLYPHS.warning}
      />
      <p
        className="
          c-update-stripe-data-modal__header
          u-max-width-300
          u-type--semibold
          u-fontsize-huge
          u-text-center
          u-mt
        "
      >
        Update your banking information
      </p>
      <p
        className="
          c-update-stripe-data-modal__text
          u-fontsize-small
          u-text-center
          u-mt
        "
      >
        There was a problem with the information you provided to set up your bank account with Squire.
        {!!props.verificationDeadline
          && (
            <Fragment>{' '}Please update your information by{' '}
              <Date format="MMMM DD">{props.verificationDeadline * 1000}</Date> to continue processing payments.
            </Fragment>
          )
        }
      </p>
      <div className="u-text-center u-mt+">
        <button
          type="button"
          className="c-btn c-btn--medium u-width-auto"
          onClick={props.onFixClick}
        >
          Update Now
        </button>
      </div>
      <div className="u-text-center u-mt">
        <button
          type="button"
          className="c-btn c-btn--blank c-btn--medium u-width-auto"
          onClick={props.onClose}
        >
          Remind me later
        </button>
      </div>
    </div>
  </Modal>
);

UpdateStripeDataWarningModal.propTypes = {
  // Component props
  isModalVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onFixClick: PropTypes.func.isRequired,
  verificationDeadline: PropTypes.number,

  /* eslint-disable react/no-unused-prop-types */
  // Passed props
  getBankAccount: PropTypes.func.isRequired,
  ownerId: PropTypes.string.isRequired,

  // Recompose props
  bankAccount: PropTypes.object,
  urlPrefix: PropTypes.string.isRequired,
  showModalIsOn: PropTypes.bool.isRequired,
  showModalOff: PropTypes.func.isRequired,
};

UpdateStripeDataWarningModal.defaultProps = {
  bankAccount: null,
  verificationDeadline: null,
};

export default UpdateStripeDataWarningModal;
